const WidgetTypes = {
  SINGLE_IMAGE: 'singleImage',
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  CHECKBOX: 'singleCheckbox',
  TEXT: 'text',
};

export default WidgetTypes;
